import { render, staticRenderFns } from "./ZhiboList.vue?vue&type=template&id=57fc02fb&scoped=true"
import script from "./ZhiboList.vue?vue&type=script&lang=js"
export * from "./ZhiboList.vue?vue&type=script&lang=js"
import style0 from "./ZhiboList.vue?vue&type=style&index=0&id=57fc02fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc02fb",
  null
  
)

export default component.exports